import { subMonths, subQuarters, startOfMonth, startOfQuarter } from "date-fns";
import type { Locale } from "@/i18n";
import type { MonthOption, QuarterOption } from "../types";

const MONTHS_DE = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
];
const MONTHS_EN = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const MONTHS_TR = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık",
];

/**
 * Build the list of last `count` *complete* months (excluding the current
 * one — current month is incomplete, the report would be partial). Newest
 * first so the picker's first option is "previous month".
 */
export function buildMonthOptions(count: number, locale: Locale): MonthOption[] {
  const monthNames =
    locale === "de" ? MONTHS_DE : locale === "tr" ? MONTHS_TR : MONTHS_EN;
  const out: MonthOption[] = [];
  const cursor = startOfMonth(subMonths(new Date(), 1));
  for (let i = 0; i < count; i++) {
    const d = subMonths(cursor, i);
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    out.push({
      month,
      year,
      label: `${monthNames[d.getMonth()]} ${year}`,
    });
  }
  return out;
}

/**
 * Last `count` complete quarters, newest first.
 */
export function buildQuarterOptions(count: number): QuarterOption[] {
  const out: QuarterOption[] = [];
  const cursor = startOfQuarter(subQuarters(new Date(), 1));
  for (let i = 0; i < count; i++) {
    const d = subQuarters(cursor, i);
    const quarter = Math.floor(d.getMonth() / 3) + 1;
    const year = d.getFullYear();
    out.push({
      quarter,
      year,
      label: `Q${quarter} ${year}`,
    });
  }
  return out;
}
